import React from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import classnames from 'classnames';
import DropDown from '../DropDown/DropDown';
import SelectDropDown from '../SelectDropDown/SelectDropDown';

import css from './styles.less';

class RegionsSelect extends React.Component {

    onChange = (value) => {
        this.props.onChangeHotelsRegions(value);
    }

    render() {
        const {
            notValid,
            isRounded,
            direction,
            titles,
            searchOptions,
            selectedOption,
            openDirection
        } = this.props;

        return (<div className=
            {classnames(
                css.regionsSelectHolder,
                isRounded && css.roundBorders,
                css[direction])}
        >

            <SelectDropDown
                notValid={notValid}
                className={css.selectDropdown}
                name="form-field-name"
                selectedOption={selectedOption}
                resetValue="..."
                placeholder={titles.searchOptionPlaceHolder}
                titles={titles}
                options={searchOptions}
                onChange={this.onChange}
                rtl={direction === 'right'}
                openDirection={openDirection}
            />

        </div>
        );
    }
};

RegionsSelect.propTypes = {
    isRounded: PropTypes.bool,
    direction: PropTypes.oneOf(['left', 'right']),
    searchOptions: PropTypes.array,
    titles: PropTypes.object,
    onChangeHotelsRegions: PropTypes.func,
    notValid: PropTypes.bool,
    openDirection:PropTypes.string
};

RegionsSelect.defaultProps = {
};

export default RegionsSelect;


// WEBPACK FOOTER //
// ./src/components/RegionsSelect/RegionsSelect.js